import { render, staticRenderFns } from "./UserSettingsGeneral.vue?vue&type=template&id=731c878d&"
import script from "./UserSettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./UserSettingsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports